import React from 'react'
import { Text } from '@resultadosdigitais/tangram-components'
import { useTranslation } from 'react-i18next'

function Header({ existAccount }) {
  const { t } = useTranslation()

  return !existAccount ? (
    <Text token={Text.tokens.TEXT_XXL_BOLD}>{t('LoginForm.Title')}</Text>
  ) : (
    <Text token={Text.tokens.TEXT_MD_BOLD}>{t('LoginForm.TileExistAccount')}</Text>
  )
}

export default Header
